import { useCallback } from 'react';
(function () {
    if (typeof window.CustomEvent === "function")
        return false;
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, !!(params === null || params === void 0 ? void 0 : params.bubbles), !!(params === null || params === void 0 ? void 0 : params.cancelable), params === null || params === void 0 ? void 0 : params.detail);
        return evt;
    }
    // @ts-ignore
    window.CustomEvent = CustomEvent;
})();
export var useEmitter = function (eventName, element) {
    if (element === void 0) { element = window; }
    var callEvent = useCallback(function (data) {
        var event = new CustomEvent(eventName, { detail: data });
        element.dispatchEvent(event);
    }, [eventName, element]);
    return callEvent;
};
